import React from 'react';
import { Link } from 'react-router-dom';

export default function Sidebar({ isOpen, onClose, signOut }) {
  const sidebarStyle = {
    position: 'fixed', top: 0, left: isOpen ? 0 : '-280px',
    width: '280px', height: '100%', background: '#2c3e50',
    transition: '0.3s', zIndex: 2000, color: '#fff', padding: '20px',
    boxSizing: 'border-box', overflowY: 'auto',
  };
  const overlayStyle = {
    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
    background: 'rgba(0,0,0,0.5)', display: isOpen ? 'block' : 'none', zIndex: 1999,
  };
  const linkStyle = {
    color: '#fff', textDecoration: 'none', display: 'block',
    padding: '15px 0', borderBottom: '1px solid #3e4f5f', fontSize: '15px',
  };

  return (
    <>
      <div style={overlayStyle} onClick={onClose} />
      <div style={sidebarStyle}>
        <h2 style={{ borderBottom: '2px solid #e74c3c', paddingBottom: '10px', marginBottom: '0' }}>メニュー</h2>
        <nav onClick={onClose}>
          <Link to="/" style={linkStyle}>🏠 ホーム</Link>
          <Link to="/timeline" style={linkStyle}>🍽️ みんなのレシピ</Link>
          <Link to="/myrecipes" style={linkStyle}>📖 Myレシピ</Link>
          <Link to="/recipe/create" style={linkStyle}>✏️ レシピを作成</Link>
          <Link to="/characters" style={linkStyle}>🎭 キャラクター変更</Link>
          <Link to="/policy" style={linkStyle}>📄 ゆきけんについて</Link>
          <Link to="/settings" style={linkStyle}>⚙️ 会員設定</Link>
        </nav>
        <button onClick={signOut} style={{ marginTop: '30px', width: '100%', padding: '12px', background: '#e74c3c', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>
          ログアウト
        </button>
      </div>
    </>
  );
}
